/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Subscriptionoverview1Inputs */

const id_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikhtisar Langganan`)
};

const ms_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambaran Keseluruhan Langganan`)
};

const da_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementsoversigt`)
};

const de_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementübersicht`)
};

const en_us2_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Overview`)
};

const es_es2_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de suscripción`)
};

const es_mx2_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de suscripción`)
};

const fil_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalahatang-ideya ng Subscription`)
};

const fr_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu des abonnements`)
};

const it_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica sottoscrizioni`)
};

const hu_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozás áttekintése`)
};

const nl_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementsoverzicht`)
};

const no_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementsoversikt`)
};

const pl_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd subskrypcji`)
};

const pt_br2_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral da assinatura`)
};

const pt_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral da subscrição`)
};

const ro_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentare generală abonament`)
};

const fi_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilausten yhteenveto`)
};

const sv_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumerationsöversikt`)
};

const vi_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan đăng ký`)
};

const tr_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Genel Bakış`)
};

const cs_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled odběrů`)
};

const bg_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ преглед на абонамента`)
};

const ru_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор подписок`)
};

const uk_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд підписок`)
};

const ar_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة على الاشتراكات`)
};

const hi_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन अवलोकन`)
};

const th_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพรวมการสมัครรับ`)
};

const ja_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション概要`)
};

const zh_cn2_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅概览`)
};

const zh_hant1_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱概覽`)
};

const ko_notifications_subscriptionoverview1 = /** @type {(inputs: Notifications_Subscriptionoverview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 개요`)
};

/**
* | output |
* | --- |
* | "Subscription Overview" |
*
* @param {Notifications_Subscriptionoverview1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_subscriptionoverview1 = /** @type {((inputs?: Notifications_Subscriptionoverview1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Subscriptionoverview1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_subscriptionoverview1(inputs)
	if (locale === "ms") return ms_notifications_subscriptionoverview1(inputs)
	if (locale === "da") return da_notifications_subscriptionoverview1(inputs)
	if (locale === "de") return de_notifications_subscriptionoverview1(inputs)
	if (locale === "en-US") return en_us2_notifications_subscriptionoverview1(inputs)
	if (locale === "es-ES") return es_es2_notifications_subscriptionoverview1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_subscriptionoverview1(inputs)
	if (locale === "fil") return fil_notifications_subscriptionoverview1(inputs)
	if (locale === "fr") return fr_notifications_subscriptionoverview1(inputs)
	if (locale === "it") return it_notifications_subscriptionoverview1(inputs)
	if (locale === "hu") return hu_notifications_subscriptionoverview1(inputs)
	if (locale === "nl") return nl_notifications_subscriptionoverview1(inputs)
	if (locale === "no") return no_notifications_subscriptionoverview1(inputs)
	if (locale === "pl") return pl_notifications_subscriptionoverview1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_subscriptionoverview1(inputs)
	if (locale === "pt") return pt_notifications_subscriptionoverview1(inputs)
	if (locale === "ro") return ro_notifications_subscriptionoverview1(inputs)
	if (locale === "fi") return fi_notifications_subscriptionoverview1(inputs)
	if (locale === "sv") return sv_notifications_subscriptionoverview1(inputs)
	if (locale === "vi") return vi_notifications_subscriptionoverview1(inputs)
	if (locale === "tr") return tr_notifications_subscriptionoverview1(inputs)
	if (locale === "cs") return cs_notifications_subscriptionoverview1(inputs)
	if (locale === "bg") return bg_notifications_subscriptionoverview1(inputs)
	if (locale === "ru") return ru_notifications_subscriptionoverview1(inputs)
	if (locale === "uk") return uk_notifications_subscriptionoverview1(inputs)
	if (locale === "ar") return ar_notifications_subscriptionoverview1(inputs)
	if (locale === "hi") return hi_notifications_subscriptionoverview1(inputs)
	if (locale === "th") return th_notifications_subscriptionoverview1(inputs)
	if (locale === "ja") return ja_notifications_subscriptionoverview1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_subscriptionoverview1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_subscriptionoverview1(inputs)
	return ko_notifications_subscriptionoverview1(inputs)
});
export { notifications_subscriptionoverview1 as "notifications.subscriptionOverview" }